export class ArrayTool {
  static replaceOrPush<T>(values: T[], value: T, predicate: (value: T, index: number, obj: T[]) => boolean) {
    const index = values.findIndex(predicate);
    if (index < 0) {
      values.push(value);
    } else {
      values[index] = value;
    }
  }

  static removeAll<Type>(array: Array<Type>, match: (item: Type) => boolean) {
    if (!array)
      return;
    var index = array.length;
    var result = [];
    while (--index >= 0) {
      if (match(array[index])) {
        var removed = array.splice(index, 1);
        result.push(removed[0]);
      }
    }
    return result;
  }

  static sum = (p: number, c: number) => (p || 0) + (c || 0);
  static concat = (p: any[], c: any[]) => (p || []).concat(c || []);

  static pairArrayItems<T, V>(items1: T[], items2: V[], matchItems: (item1: T, item2: V) => boolean): [T, V][] {
    items2 = items2.slice();
    const result1 = items1.map(item1 => {
      const index = items2.findIndex(item2 => matchItems(item1, item2));
      if (index < 0) {
        return [item1, undefined] as [T, V];
      } else {
        const item2 = items2.splice(index, 1)[0];
        return [item1, item2] as [T, V];
      }
    });
    const result2 = items2.map(item2 => ([undefined, item2] as [T, V]));
    const result = result1.concat(result2);
    return result;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/tools/array-tool.ts